import React, { useContext, useEffect } from 'react'
import { Stack, Typography } from '@mui/material'
import { Chip } from 'components/generic/chip'
import ContentLayoutContext from 'components/layouts/ContentLayoutContextProvider'
import TabsLayoutContext from 'components/layouts/TabsLayoutContextProvider'
import FORM_MODALS from 'utils/ui/modals'
import { useDispatch, useSelector } from 'react-redux'
import store from 'state/store'
import { Edit } from '@mui/icons-material'
import { showFormModal } from 'state/ui'
import { CUSTOMER_TAB_ROUTES } from 'utils/ui/routes'

export const useCustomerHeader = customerData => {
  const contentContext = useContext(ContentLayoutContext)
  const tabsContext = useContext(TabsLayoutContext)
  const dispatch = useDispatch()
  const { settings } = useSelector(state => state.settings)
  const showCashCardButton = settings?.purchaseSettings?.payment?.mreEntityId

  useEffect(() => {
    const pageActions = [
      {
        text: 'Edit customer',
        id: 'edit-customer',
        onClick: () =>
          store.dispatch(
            showFormModal({
              formModalName: FORM_MODALS.NEW_CUSTOMER,
              formModalProps: { customerId: customerData?.id },
            }),
          ),
        icon: <Edit />,
      },
    ]

    if (showCashCardButton) {
      pageActions.unshift({
        text: customerData?.contacts?.[0]?.texasCashCardId ? 'VIEW CASH CARD' : 'CREATE CASH CARD',
        variant: 'outlined',
        id: 'cash-card',
        onClick: () => {
          dispatch(
            showFormModal({
              formModalName: FORM_MODALS.CREATE_CASH_CARD,
              formModalProps: { customerData },
            }),
          )
        },
      })
    }
    // update Title
    contentContext.setContainerTitle(
      customerData?.archive ? (
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <Typography variant="h5">{customerData?.customerCommonIdentifierString}</Typography>
          <Chip label="Archived" sx={{ marginLeft: '16px' }} />
        </Stack>
      ) : (
        customerData?.customerCommonIdentifierString || '---'
      ),
    )

    // update actions
    if (!customerData?.archive) {
      contentContext.setContainerActions(pageActions)
    }

    // update tabs
    tabsContext.setContainerTabs(
      !customerData?.isCarrier ? CUSTOMER_TAB_ROUTES : CUSTOMER_TAB_ROUTES.filter(({ title }) => title !== 'Vehicles'),
    )
  }, [customerData])
}
